import React, { lazy } from "react"
import { Navigate } from "react-router-dom"

// Authentication — kept small, load eagerly so login is instant
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"

// All other pages — lazy loaded (code split per route)
const Dashboard            = lazy(() => import("../pages/Dashboard/index"))
const Stores               = lazy(() => import("../pages/Stores/index"))
const MerchantsDetails     = lazy(() => import("../pages/Stores/merchantDetails"))
const UninstalledStores    = lazy(() => import("../pages/Stores/uninstalledStores"))
const PlacementEdit        = lazy(() => import("pages/Stores/PlacementEdit"))
const ChargeEdit           = lazy(() => import("pages/Stores/ChargeEdit"))
const SettingEdit          = lazy(() => import("pages/Stores/CommonSettingsEdit"))
const CampaignChargeEdit   = lazy(() => import("pages/Stores/campaignChargeEdit"))
const DiscountTypeEdit     = lazy(() => import("pages/Stores/DiscountTypeEdit"))
const PriceSelectorEdit    = lazy(() => import("pages/Stores/PriceSelectorEdit"))
const CampaignMetafields   = lazy(() => import("pages/Stores/CampaignMetafieldsEdit"))
const UploadRosterCSV      = lazy(() => import("pages/Stores/UploadRosterCSV"))
const BlockedCouponView    = lazy(() => import("pages/Stores/BlockedCouponView"))
const LatestBlockedOrdersView = lazy(() => import("pages/LatestBlockedOrders/index"))
const PlanInfo             = lazy(() => import("pages/Stores/PlanInfo"))
const Platform             = lazy(() => import("pages/Platform/index"))
const StoresHandle         = lazy(() => import("pages/StoreHandler/index"))
const Logs                 = lazy(() => import("pages/Logs/index"))
const UsageCharge          = lazy(() => import("pages/usageCharge/index"))
const ScannerWebsite       = lazy(() => import("pages/ScannerWebsite/index"))
const ScannerCoupon        = lazy(() => import("pages/CouponScanner/index"))
const ScannerCouponStore   = lazy(() => import("pages/ReferenceStore/index"))
const CouponAnalyzer       = lazy(() => import("pages/CouponAnalyzer/index"))
const BlockedOrdersAnalytics = lazy(() => import("pages/BlockedOrdersAnalytics/index"))
const BlockedOrdersInsights = lazy(() => import("pages/BlockedOrdersInsights/index"))
const OrdersAnalytics      = lazy(() => import("pages/OrdersAnalytics/index"))
const ClientReviewList     = lazy(() => import("pages/ClientReviewList/index"))
const AppConfig            = lazy(() => import("pages/AppConfig/index"))
const Pages404             = lazy(() => import("../pages/Utility/pages-404"))
const Pages500             = lazy(() => import("../pages/Utility/pages-500"))

const authProtectedRoutes = [
  { path: "/stores",                   component: Stores },
  { path: "/dashboard",                component: Dashboard },
  { path: "/placement-edit",           component: PlacementEdit },
  { path: "/usage-charges-edit",       component: ChargeEdit },
  { path: "/common-setting-edit",      component: SettingEdit },
  { path: "/campaign-charge-edit",     component: CampaignChargeEdit },
  { path: "/blocked-coupon",           component: BlockedCouponView },
  { path: "/latest-blocked-orders",    component: LatestBlockedOrdersView },
  { path: "/plan-info",                component: PlanInfo },
  { path: "/upload-roster-csv",        component: UploadRosterCSV },
  { path: "/merchant-details",         component: MerchantsDetails },
  { path: "/discount-type-edit",       component: DiscountTypeEdit },
  { path: "/uninstalled-stores",       component: UninstalledStores },
  { path: "/price-selector-edit",      component: PriceSelectorEdit },
  { path: "/campaign-metafields-edit", component: CampaignMetafields },
  { path: "/scanner-website",          component: ScannerWebsite },
  { path: "/coupon-scanner",           component: ScannerCoupon },
  { path: "/reference-store",          component: ScannerCouponStore },
  { path: "/coupon-analyzer",          component: CouponAnalyzer },
  { path: "/blocked-orders-analytics", component: BlockedOrdersAnalytics },
  { path: "/blocked-orders-insights",  component: BlockedOrdersInsights },
  { path: "/orders-analytics",        component: OrdersAnalytics },
  { path: "/platform",                 component: Platform },
  { path: "/auto-bcl",                 component: StoresHandle },
  { path: "/logs",                     component: Logs },
  { path: "/usage-charge",             component: UsageCharge },
  { path: "/client-review-list",       component: ClientReviewList },
  { path: "/app-config",               component: AppConfig },
]

const publicRoutes = [
  { path: "/login",      component: Login },
  { path: "/logout",     component: Logout },
  { path: "/profile",    component: Register },
  { path: "/pages-404",  component: Pages404 },
  { path: "/pages-500",  component: Pages500 },
  {
    path: "/",
    exact: true,
    component: () => localStorage.getItem("authUser")
      ? <Navigate to="/dashboard" />
      : <Navigate to="/login" />,
  },
]

export { authProtectedRoutes, publicRoutes }
